<template>
  <div>
    <div class="divider mx0 my3"></div>

    <span class="h3">
    END USER LICENCE AGREEMENT
    </span>
    <br><br>

    between
    <br>
    HEINZE COBIAX DEUTSCHLAND GMBH 
    <br>
    Eupener Straße 35
    <br>
    32051 Herford, Germany
    <br>
    legally represented by the management
    <br>
    Jörg Tilmes and Volkmar Wanninger
    <br>
    hereinafter referred to as Heinze Cobiax
    <br>
    <br>

    and
    <br>
    the user of the software application "CQL" of HEINZE COBIAX DEUTSCHLAND
    <br>
    <br>

    <span class="semibold">
    IMPORTANT NOTICE: READ THIS END USER LICENCE AGREEMENT CAREFULLY AND MAKE SURE YOU UNDERSTAND IT BEFORE ACCEPTING ITS TERMS.
    <br>

    HEINZE COBIAX IS ONLY WILLING TO LICENSE THE SOFTWARE APPLICATION DEFINED BELOW TO YOU AS A CONSUMER OR A CONTRACTOR ("USER") IF YOU ACCEPT ALL OF THE TERMS OF THIS END USER LICENSE AGREEMENT AND THE ACCOMPANYING TERMS AND CONDITIONS.
    <br>
    BY CLICKING ON THE "ACCEPT CQL TERMS OF USE" BUTTON, BY USING THE SOFTWARE APPLICATION, OR BY OTHERWISE EXPRESSING YOUR ACCEPTANCE, YOU ACCEPT THIS END USER LICENSE AGREEMENT, AND THIS END USER LICENSE AGREEMENT SHALL ESTABLISH A LEGAL AND APPLICABLE CONTRACT BETWEEN HEINZE COBIAX AND YOURSELF, IF YOU ARE A CONSUMER, OR BETWEEN HEINZE COBIAX AND YOUR BUSINESS ENTITY, IF YOU ARE A CONTRACTOR.
    <br>
    THE CONCLUSION OF THE END USER LICENCE AGREEMENT IS NECESSARY FOR THE LEGITIMATE USE OF THE SOFTWARE APPLICATION "CQL" (HEREINAFTER REFERRED TO AS "SOFTWARE").
    <br>
    IF YOU DO NOT AGREE TO THESE TERMS, CLICK THE BUTTON "CANCEL".
    </span>
    <br>
    <br>
    <b class="h4">§ 1	Subject matter of the Agreement / Scope of Application</b>
    <span class="flex mt1">
      <span class="mr3">(1)</span>
      <span>The subject matter of the contract is the software application "CQL" in its current version at the time of provision.</span>
    </span>
    <span class="flex">
      <span class="mr3">(2)</span>
      <span>The software is a program to support the planning of a ceiling with Cobiax void elements.</span>
    </span>
    <span class="flex">
      <span class="mr3">(3)</span>
      <span>The software source code is not subject matter of the contract.</span>
    </span>
    <span class="flex">
      <span class="mr3">(4)</span>
      <span>These Terms of Use shall not apply to updates and upgrades of the Software; in these cases Heinze Cobiax expressly reserves the right to link the use to future conditions, especially to a registration of the user.</span>
    </span>
    <br>
    <b class="h4">§2	Grant of Rights</b>
    <span class="flex mt1">
      <span class="mr3">(1)</span>
      <span>The Software is legally protected by copyright laws, contracts and by other laws. Heinze Cobiax owns and retains all right, title and interest to the Software, including all copyrights, patents, trade secrets, trademarks and other intellectual property rights. This End User Licence Agreement in no way transfers ownership of the Software at all to the User. Except for the rights described in § 2 (2), the User shall not obtain any rights with regard to the Software.</span>
    </span>
    <span class="flex">
      <span class="mr3">(2)</span>
      <span>Heinze Cobiax grants User the royalty-free, non-exclusive, non-transferable right, revocable at any time, to use the Software solely in connection with the (potential) use of Cobiax Products.</span>
    </span>
    <span class="flex mb1">
      <span class="mr3">(3)</span>
      <span>User shall not, and shall not permit any other person to:</span>
    </span>
    <span class="flex">
      <span class="ml3 pl2 mr3">a.</span>
      <span>Copy (except for backup purposes), sublicense, rent, lend or lease any part of the Software.</span>
    </span>
    <span class="flex">
      <span class="ml3 pl2 mr3">b.</span>
      <span>Modify the Software in whole or in part or create derivative works based in whole or in part on the Software.</span>
    </span>
    <span class="flex">
      <span class="ml3 pl2 mr3">c.</span>
      <span>Remove, modify or obscure any ownership markings, serial numbers, labels or copy protection features from the Software. This also applies to any supression of the display of corresponding notes and features on the screen.</span>
    </span>
    <span class="flex mb1">
      <span class="ml3 pl2 mr3">d.</span>
      <span>To modify the software.</span>
    </span>
    <span class="flex">
      <span class="mr3">(4)</span>
      <span>The user is only permitted to copy the software to the extent that this is absolutely necessary for the contractual use of the software. A necessary copying is loading the software into the random access memory. The user is not permitted to make any other copies, including printing out the programme code on a printer.</span>
    </span>
    <span class="flex">
      <span class="mr3">(5)</span>
      <span>The software may not be reproduced, distributed or decompiled (i.e. reverse engineered into source code) unless expressly permitted by this Agreement or by law. If the User wishes to reverse engineer, decompile or disassemble (hereinafter referred to as "decompilation") the Software in order to achieve interoperability with other computer programs where permitted by law, the User shall contact Heinze Cobiax prior to decompiling the Software and request that Heinze Cobiax provide the information necessary to achieve such interoperability. If Heinze Cobiax provides such information regarding interoperability upon request without culpable delay, the user shall not be entitled to decompile the computer program.</span>
    </span>
    <span class="flex">
      <span class="mr3">(6)</span>
      <span>Heinze Cobiax expressly points out that any violation of the aforementioned licence conditions or other contractual provisions shall be prosecuted under civil and, if necessary, criminal law.</span>
    </span>

  
    <br>

    <b class="h4">§ 3	Claims for Defects, Liability</b>
    <span class="flex mt1">
      <span class="mr3">(1)</span>
      <span>Heinze Cobiax shall be liable exclusively for intent and gross negligence. Any further liability shall be excluded.</span>
    </span>
    <span class="flex">
      <span class="mr3">(2)</span>
      <span>Heinze Cobiax shall only be liable for damages if Heinze Cobiax fraudulently conceals a defect in the law or a defect in the software. Any further liability for defects shall be excluded.</span>
    </span>
    <span class="flex">
      <span class="mr3">(3)</span>
      <span>In no case shall Heinze Cobiax be liable for lack of economic success, loss of profit and/or indirect damages. The User shall be responsible for regularly backing up its data. In the event of a loss of data for which Heinze Cobiax is responsible, Heinze Cobiax shall therefore be liable in accordance with the above provision solely for the costs of copying the data, the backup copies to be made and for the costs of restoring the data that would have been lost even if the data had been properly backed up.</span>
    </span>
    <span class="flex">
      <span class="mr3">(4)</span>
      <span>Any claims for damages against Heinze Cobiax shall become invalid within two years from the date of the first registration.</span>
    </span>
    <span class="flex">
      <span class="mr3">(5)</span>
      <span>It is pointed out that it is not possible to create computer software in such a manner that it works error-free in all combinations and applications. Heinze Cobiax therefore accepts no liability for the correctness and the completeness of the software. The user shall remain responsible for checking the input and output values against current documents (standards, approvals, product descriptions, etc.) to ensure that they are free of errors.</span>
    </span>
    <span class="flex">
      <span class="mr3">(6)</span>
      <span>Any kind of liability and/or warranty shall be excluded if the use of the software is not exclusively related to the potential use of Cobiax products.</span>
    </span>
    <br>

    <b class="h4">§ 4	Non-disclosure</b>
    <br>
    <span class="flex mt1 mb1">
    <span class="">The User shall treat all programs, codes and documentation as well as concepts supplied by Heinze Cobiax as trade and business secrets of Heinze Cobiax and keep them strictly confidential.
    </span>
    </span>
    <br>
    <b class="h4">§ 5	General</b>
    <span class="flex mt1">
      <span class="mr3">(1)</span>
      <span>All agreements which involve a change, addition or specification of these contractual terms and conditions as well as any special commitments, warranties and agreements shall be set down in writing. This also applies to the amendment of the written form requirement. If they are declared by third parties or auxiliary persons of Heinze Cobiax, they shall only be binding if Heinze Cobiax gives its written consent to them.</span>
    </span>
    <span class="flex">
      <span class="mr3">(2)</span>
      <span>The User shall be entitled to any set-off only to the extent that a counterclaim to which the User is entitled has been finally determined by a court of law or has been acknowledged by Heinze Cobiax or is undisputed. The user may only exercise a right of retention insofar as it relates to claims arising from this contract.</span>
    </span>
      <span class="flex">
      <span class="mr3">(3)</span>
      <span>German law shall apply exclusively to the exclusion of the CISG. The place of jurisdiction for all legal disputes arising from this contract is - as far as legally allowed - Bielefeld.</span>
    </span>
    <span class="flex">
      <span class="mr3">(4)</span>
      <span>By accepting these Terms of Use, the User also agrees to be regularly informed by an electronic newsletter about innovations to the products, the software or other operational matters and facts worth mentioning from the construction industry of Heinze Cobiax.</span>
    </span> 
    <span class="flex">
      <span class="mr3">(5)</span>
      <span>Should any provision of this Agreement be or become invalid, the validity of the remaining provisions of this Agreement shall not be affected thereby. The contracting parties shall be obliged, within the bounds of what is reasonable and in good faith, to replace the invalid provision with a valid provision that comes as close as possible to the invalid provision in economic terms, provided that this does not result in any material change to the content of the contract.</span>
    </span>  
  </div>  

</template>

<script>

export default {
  name: 'contract-text-de',
}
</script>

<style scoped>
</style>